var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 18.3332C5.39685 18.3332 1.66602 14.6023 1.66602 9.99984C1.66602 5.39734 5.39685 1.66651 9.99935 1.66651C11.2932 1.66553 12.5695 1.96632 13.7268 2.54496C14.8841 3.1236 15.8905 3.96415 16.666 4.99984H14.4077C13.4454 4.15131 12.2587 3.59847 10.9899 3.40767C9.72123 3.21687 8.4244 3.39622 7.25509 3.92418C6.08577 4.45215 5.09364 5.30631 4.39774 6.38416C3.70184 7.46202 3.33174 8.71778 3.33185 10.0008C3.33195 11.2837 3.70226 12.5394 4.39834 13.6172C5.09442 14.6949 6.0867 15.5489 7.2561 16.0767C8.4255 16.6045 9.72236 16.7836 10.991 16.5926C12.2597 16.4016 13.4464 15.8485 14.4085 14.9998H16.6668C15.8912 16.0356 14.8847 16.8763 13.7273 17.4549C12.5698 18.0336 11.2934 18.3343 9.99935 18.3332ZM15.8327 13.3332V10.8332H9.16602V9.16651H15.8327V6.66651L19.9993 9.99984L15.8327 13.3332Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.3771a1164632b234500d7ba248efafd3.svg";
export { ForwardRef as ReactComponent };